// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  thinkoaiUrl: 'https://tai-dev.thinkoai.com/',
  tekmanDigital: 'https://dev.tekmandigital.com/',
  coreApiV7: 'https://core-dev.tekman.cloud/api/v7',
  contactUrlEsp: 'https://www.tekmaneducation.com/contacta/',
  contactUrlCa: 'https://www.tekmaneducation.com/ca/contacta-amb-nosaltres/',
  activityCategories: [
    {
      name: 'exercises',
      typologies: ['base-camp-exercise', 'challenge-exercise', 'oxigen-exercise'],
    },
    {
      name: 'self-assessment',
      typologies: ['test-yourself'],
    },
    {
      name: 'tests',
      typologies: ['self-assessment-test'],
    },
  ],
  materials: {
    url: 'https://materials-api-pre.tekman.cloud/api/v2',
    key: 'test',
    value: 'test',
  },
  qrTracker: 'https://qr-dev.tekman.cloud/#V',
  bigqueryUrl: 'https://bigquery-proxy-245947785164.europe-west2.run.app/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
